import React from "react"
import { Link } from "gatsby"
import { Container, Breadcrumb, BreadcrumbItem, Row, Col } from "reactstrap"
import Layout from "./../components/layout"
import SEO from "./../components/seo"
import "../style/products.css"

function DataExtracts() {
  return (
    <Layout>
      <SEO />
      <Breadcrumb className="breadCrumb">
        <BreadcrumbItem>
          <Link className="breadCrumbLinks" to="/">
            Home
          </Link>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <Link className="breadCrumbLinks" to="/products">
            Products
          </Link>
        </BreadcrumbItem>
        <BreadcrumbItem active>Simple Data Extracts</BreadcrumbItem>
      </Breadcrumb>
      <Container>
        <h1>Simple Data Extracts (SDE)</h1>
        <h4
          style={{
            textAlign: "center",
            backgroundColor: "#2780E3",
            color: "white",
          }}
        >
          Quick and Easy SAS® File Data Extraction
        </h4>
        <h2>Features:</h2>
        <ul style={{ listStyleType: "square" }}>
          <li>
            Implemented as a standard SAS® PROC to simplify both installation
            and operation
          </li>
          <li>Optional 'WHEN' clauses</li>
          <li>SAS® Variable selection</li>
          <li>Data conversion with FORMAT statements</li>
          <li>Width parameter to vary output field size</li>
          <li>NULLS option to add null fields to output</li>
          <li>CSV, PRN and DIF output formats</li>
        </ul>
        <h4>
          The following sample of SDE code is designed to show how SDE can be
          used
        </h4>
        <Row style={{ textAlign: "center" }}>
          <Col xs="0" sm="2" md="3" lg="4"></Col>
          <Col xs="12" sm="8" md="6" lg="4">
            <table width="100%">
              <tr
                style={{
                  borderStyle: "solid",
                  borderWidth: "5px",
                  borderColor: "#454851",
                }}
              >
                <th>
                  <h4>SAMPLE#1</h4>
                  <p>
                    This very simple code builds a SAS® file and then extracts
                    only two fields to a CSV format file
                  </p>
                </th>
              </tr>
              <tr
                style={{
                  borderStyle: "solid",
                  borderWidth: "5px",
                  borderColor: "#454851",
                }}
              >
                <th style={{ textAlign: "left", padding: "5px" }}>
                  DATA T1 ; INFILE CARDS
                  <br />
                  INPUT SASCH1 $10. +1 SASNUM1 5. ;<br />
                  FORMAT SASCH1 $CHAR5. ;<br />
                  FORMAT SASNUM1 5.2. ;<br />
                  CARDS ;<br />
                  ABSDEFGHIJ 12345 ;<br />
                  PROC SDE ;<br />
                  CONTROL CSV ;<br />
                  SELECT SASCH1 FORMAT ;<br />
                  SELECT SASNUM1 FORMAT ;<br />
                </th>
              </tr>
              <tr
                style={{
                  borderStyle: "solid",
                  borderWidth: "5px",
                  borderColor: "#454851",
                }}
              >
                <th style={{ textAlign: "left", padding: "5px" }}>
                  <p>
                    The output file will contain the data in CSV format as
                    follows:
                  </p>
                  "ABCDE",123.45
                </th>
              </tr>
            </table>
          </Col>
          <Col xs="0" sm="0" md="3" lg="4"></Col>
        </Row>
      </Container>
    </Layout>
  )
}

export default DataExtracts
